// Module
var code = "<div class=\"about\"> <h1>页面未找到</h1> <h2>1yayaya</h2> </div> ";
// Exports
module.exports = code;